import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

class WorkingModal extends Component{
  constructor(props) {
    super(props);
    
    this.state = {
      name: this.props.name || ""
    }
  }

  handleChange = (e) => {
    this.setState({name: e.target.value})
  }

  render() {
    let {action, dismiss, mode} = this.props;

    return (
      <Modal.Dialog className="setting-working-modal">
        <Modal.Header>
          <Modal.Title>
            修改資料
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form-horizontal">
            <div className="form-group" >
              <label className="col-sm-2 control-label">名稱</label>
              <div className="col-sm-10">
                <input                    
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleChange}
                  className="form-control"/>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button 
            className="btn btn-primary"
            onClick={()=>{action(this.state.name)}}>
            {(mode === 'EDIT'? "修改": "新增")}
          </button>
          <button
            className="btn btn-default"
            onClick={dismiss}>
            關閉
          </button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}


export default WorkingModal;



// WEBPACK FOOTER //
// ./src/components/Setting/WorkingModal.js